		export const commonPathTermsToIgnore: string[] = [
			'search', 'home', 'about', 'contact', 'help', 'privacy', 'terms', 'login', 'register', 'signup',
			'logout', 'signout', 'settings', 'profile', 'dashboard', 'search results', 'results', 'submit', 'cancel',
			'continue', 'next', 'previous', 'back', 'forward', 'refresh', 'reload', 'close', 'open', 'save', 'download',
			'upload', 'delete', 'edit', 'view', 'more', 'less', 'show', 'hide', 'filter', 'sort',
			'clear', 'reset', 'apply', 'ok', 'yes', 'no', 'maybe', 'cancel', 'confirm', 'agree', 'disagree',
			'accept', 'decline', 'partners', 'advertisers', 'sponsors', 'affiliates',
			'about us', 'contact us', 'privacy policy', 'terms of service', 'user agreement',
			'cookie policy', 'data policy', 'legal', 'disclaimer', 'support', 'faq', 'help center',
			'knowledge base', 'community', 'forum',
			'blog', 'news', 'updates', 'events', 'careers', 'jobs', 'press', 'media', 'resources',
			'developers', 'api', 'documentation', 'guides', 'tutorials', 'examples', 'samples',
			'feedback', 'true', 'false', 'enable', 'disable', 'none',
		].map( s => s.replaceAll(' ', '-'));